module.exports = __webpack_public_path__ + "media/alert-tone.65a2df7a.wav";